import {FC} from "react";
import {Eye, Mail, Map, MapPin, MoveRight, Phone} from "lucide-react";
import Link from "next/link"; // Icons from Shadcn UI

interface LocationCardProps {
    id: string;
    title: string;
    address: string;
    email: string;
    phone: string;
    hours: string;
    imgUrl: string;
    linkMaps?: string;
    slug?: string;
    onSelect?: (id: string) => void;
}

const LocationCard: FC<LocationCardProps> = ({
                                                 id,
                                                 title,
                                                 address,
                                                 email,
                                                 phone,
                                                 hours,
                                                 imgUrl,
                                                 linkMaps,
                                                 slug,
                                                 onSelect
                                             }) => {
    return (
        <div
            className="border-2 border-primary border-opacity-30 flex max-md:flex-row max-md:gap-x-2 flex-col md:flex-row items-start p-4 shadow rounded-xl bg-white max-md:bg-[#EAEBF4] mb-4">
            <div className="flex-shrink-0 max-md:w-auto w-full md:w-auto max-md:mb-0 mb-4 md:mb-0">
                <img
                    src={imgUrl}
                    alt={title}
                    className="object-cover rounded-md w-full max-md:w-[150px] md:w-auto"
                />
            </div>
            <div className="ml-0 md:ml-4 flex-grow">
                <div className="flex items-center justify-between">
                    <span className="text-xs  text-black font-semibold">APERTO ORA</span>
                    <span className="text-xs text-black">{hours}</span>
                </div>
                <h3 className="font-bold text-lg">{title}</h3>
                <div className="md:hidden flex flex-row justify-between pt-3 items-center">
                    <a hrefLang="it" href={`tel:${phone}`} className=" p-3 text-white bg-[#000D7D] rounded-full">
                        <Phone size={16}/>
                    </a>
                    <a hrefLang="it" href={`mailto:${email}`} className=" p-3 text-white bg-[#000D7D] rounded-full">
                        <Mail size={16}/>
                    </a>
                    <Link hrefLang="it" href={linkMaps || "#"} target="_blank" rel="noopener noreferrer"
                          className=" p-3 text-white bg-[#000D7D] rounded-full">
                        <Map size={16}/>
                    </Link>
                </div>
                <div className="text-sm text-black max-md:hidden">
                    <div className="flex max-md:text-xs items-center gap-x-2 p-2">
                        <MapPin className="w-4 h-4 text-[#000D7D]"/>
                        {address}
                    </div>
                    <div className="flex max-md:text-xs items-center gap-x-2 p-2">
                        <Mail className="w-4 h-4 text-[#000D7D]"/>
                        {email}
                    </div>
                    <div className="flex justify-between">
                        <div className="flex max-md:text-xs items-center gap-x-2 p-2">
                            <Phone className="w-4 h-4 text-[#000D7D]"/>
                            {phone}
                        </div>
                        <div className="flex items-center gap-x-2">
                            <button
                                className="ml-auto p-2 text-white bg-[#000D7D] rounded-full"
                                onClick={() => onSelect && onSelect(id)}
                            >
                                <MapPin/>
                            </button>
                            <Link href={'/dove-siamo/' + slug} hrefLang="it" lang="it"
                                className="ml-auto p-2 text-white bg-[#000D7D] rounded-full"
                            >
                                <Eye/>
                            </Link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default LocationCard;
